<template>
  <div id="app">
    <Menubar />
    <RouterView />
    <PageFooter />
    <Modal />
  </div>
</template>

<script>
import Menubar from "@/components/Menubar";
import PageFooter from "@/components/PageFooter";
import Modal from "@/components/Modal";

export default {
  name: "App",
  components: { Menubar, PageFooter, Modal },
  watch: {
    $route: {
      handler: (to) => {
        document.title = to.meta.title;
        document.head.querySelector('meta[name=description]').content = to.meta.description;
        document.head.querySelector('meta[property="og:description"]').content = to.meta.description;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: Roboto;
  src: url(./assets/font/Roboto-Light.ttf);
  font-weight: 300;
}

@font-face {
  font-family: Roboto;
  src: url(./assets/font/Roboto-Regular.ttf);
  font-weight: 400;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
}

body {
  @extend #{$font-size};
  background-color: $background-color-primary-1;
  font-family: $font-family;
  font-weight: $font-weight;
  color: $color-primary-1;
  overflow-y: scroll;
}

a {
  color: $color-secondary-1;
}

.colored {
  color: $color-secondary-1;
}
</style>
